import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight, FiBookOpen } = FiIcons;

function CurriculumGrid({ domains, completedLessons }) {
  return (
    <section className="curriculum-section" id="curriculum">
      <div className="container">
        <div className="section-heading">
          <div>
            <span className="section-kicker">Online Self-Paced Career Training</span>
            <h2>Classes & Study Modules</h2>
          </div>
          <p>Five essential medical billing and coding subjects designed to take you from foundational concepts to exam-ready proficiency in MB&C at your own pace.</p>
        </div>

        <div className="curriculum-grid">
          {domains.map((domain, index) => {
            const completed = domain.lessons.filter((lesson) =>
              completedLessons.includes(lesson.id)
            ).length;

            return (
              <motion.article
                className={`domain-card accent-${domain.accent}`}
                key={domain.id}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.4, delay: index * 0.06 }}
              >
                <Link to={`/module/${domain.id}`} aria-label={`Open ${domain.title}`}>
                  <div className="card-topline">
                    <span>{domain.number}</span>
                    <SafeIcon icon={FiArrowUpRight} />
                  </div>
                  <div className="domain-icon">
                    <SafeIcon name={domain.icon} />
                  </div>
                  <h3>{domain.title}</h3>
                  <p>{domain.description}</p>
                  <div className="card-meta">
                    <span><SafeIcon icon={FiBookOpen} /> {domain.lessons.length} lessons</span>
                    <strong>{completed}/{domain.lessons.length} complete</strong>
                  </div>
                </Link>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default CurriculumGrid;